import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { ManagedSettingsDataRoamingComponent } from './data-roaming.component';

@Component({
  selector: 'ml-data-roaming',
  templateUrl: 'data-roaming.container.html',
  imports: [ManagedSettingsDataRoamingComponent],
})
export class ManagedSettingsDataRoamingContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  dataRoaming(dataRoamingEnabled: boolean) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.dataRoaming({
        udid: this.udid,
        enabled: dataRoamingEnabled,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
